import { gql } from '@apollo/client';

/**
 * Description - graphql query to delete an sub theme
 */
export const DELETE_SUB_THEME_TEMPLATE_CHECKLIST = gql`
  mutation delete_soft_qat_sub_theme_template_checklist_by_pk(
    $id: Int!
    $deletedDate: timestamptz
  ) {
    update_qat_sub_theme_template_checklist_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_date: $deletedDate }
    ) {
      id
    }
  }
`;
